import styled, { css } from 'styled-components';
import Tokens from '@nokia-csf-uxr/freeform-design-tokens';

export default {
  FieldSet: styled.fieldset`
    padding: 0;
    margin: 0;
    border: none;
    max-width: 100%;
    min-width: 0;
    display: inline;
    ${props => css`direction: ${(props.RTL || props.$rtl || props.rtl) ? 'rtl' : 'ltr'}`};
  `,
  FieldSetContent: styled.div`
    ${props => css`direction: ${(props.RTL || props.$rtl || props.rtl) ? 'rtl' : 'ltr'}`};
    max-width: 100%;
    display: flex;
    ${props => props.isHorizontal ? css`
      flex-direction: row;
      & > * :not(:last-child) {
        margin-right: 0.25rem
      }
  ` : css`
      flex-direction: column;
  `}
`,
  Legend: styled.legend`
    ${props => css`direction: ${(props.RTL || props.$rtl || props.rtl) ? 'rtl' : 'ltr'}`};
    ${Tokens.TYPOGRAPHY.LABEL};
    margin-bottom: ${Tokens.SPACING.SPACING_8};
    color: ${({ $theme }) => $theme.content};
    min-width: 100%;
    padding: 0;
  `
};